import { nl, fr, enGB, es } from 'date-fns/locale'
import useAppState from './useAppState'

export default function useDateFnsLocale() {
    const { preferredCultureCode } = useAppState()
    switch (preferredCultureCode) {
        case 'nl':
            return nl
        case 'fr':
            return fr
        case 'es':
            return es
        case 'en':
        default:
            return enGB
    }
}
